var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"main-wrap"}},[(_vm.injected)?_c('v-main',[_c('v-fade-transition',{attrs:{"hide-on-leave":""}},[_c('router-view',{key:_vm.$route.name})],1),(!_vm.$store.state.auth)?_c('CookieNotice'):_c('EntitiesSnackbar')],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }